import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Normalizes the on-URL representation of `?client=`:
 *   - upper-cases the value so the URL bar matches the canonical client code.
 *   - reorders so `client` is the first query param.
 *
 * Both concerns live here because they are the only places that cosmetically
 * rewrite an otherwise-valid URL; doing them in the same effect means
 * consumers see at most one re-render to settle the URL.
 */
export const usePinClientParamFirst = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const client = searchParams.get('client');
    if (!client) return;

    const canonical = client.toUpperCase();
    const [firstKey] = searchParams.keys();
    if (firstKey === 'client' && client === canonical) return;

    const reordered = new URLSearchParams();
    reordered.set('client', canonical);
    for (const [key, value] of searchParams.entries()) {
      if (key !== 'client') reordered.append(key, value);
    }

    setSearchParams(reordered, { replace: true });
  }, [searchParams, setSearchParams]);
};
